import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { DownloadableConfigurationFiles } from '../../../_lib/components/ConfigurationFileUpload';

type UserImportConfigurationFile = {
  fileExportType: 'standard' | 'customized';
  fileExtension: 'yaml' | 'json';
  url: string;
};

type UserImportConfigurationDefaultProps = { files: UserImportConfigurationFile[] };

function UserImportConfigurationDefault({ files }: UserImportConfigurationDefaultProps) {
  const { uuid, elementType } = useBlockContext();
  const { t } = useSonTranslation('UserImportConfiguration');
  return (
    <DownloadableConfigurationFiles
      key={`${elementType}-${uuid}`}
      files={files.map(file => ({
        extension: file.fileExtension,
        url: file.url,
        name: t(`fileExportType.${file.fileExportType}`),
      }))}
    />
  );
}

export const UserImportConfigurationDefaultView = asView(UserImportConfigurationDefault);
export type UserImportConfigurationDefaultView = ComponentProps<typeof UserImportConfigurationDefaultView>;
